import dataClient from '@/graphql/clients/axios';

const state = {
    myGroup: {},
    selected: {},
    list: [],
    adminList: [],
    groupPage: null,
    groupPageLoading: false
};

const getters = {
  selected: state => state.selected,
  list: state => state.list,
  myGroup: state => state.myGroup,
  groupPage: state => state.groupPage,
  getGroupPageLoading: state => state.groupPageLoading
};

const actions = {
    initGroups: ({commit}, info) => {
        const {
            myGroup,
            groups,
            myUser,
            linkedUsers
        } = info;
        // Set my group
        commit('setMyGroup', myGroup)
        // Populate from database after prototyping
        commit('setList', { groups: [myGroup, ...groups], linkedUsers: [myUser, ...linkedUsers] })
        // set selected
        commit('changeGroup', myGroup)
    },
    changeGroup: ({commit,getters}, _id) => commit('changeGroup', group),
    sendGroupPageSms: async ({rootState, dispatch, commit, getters, rootGetters}, params) => {
        console.log('params', params)

        let group = rootGetters['profile/getGroup']

        if (group && group.id) {
            let parameters = []
            parameters.push({
              id: 'group_id',
              value: group.id
            })
            parameters.push({
                id: 'id',
                value: params.message._id
            })
            parameters.push({
                id: 'text',
                value: params.text
            })
            parameters.push({
                id: 'field_id',
                value: params.fieldId
            })      
            parameters.push({
                id: 'user_id',
                value: rootGetters['profile/getUserID'],
            })   

            if (params.confirm)  {
                parameters.push({
                    id: 'confirm',
                    value: 'true'
                })
            }
 
            let response = await dataClient('providerPageSet', {operation: 'group_sms', parameters: parameters})

            return response
        }        

    },
    groupConfirmMessages: async ({rootState, dispatch, commit, getters, rootGetters}, params) => {

        console.log('params', params)

        let group = rootGetters['profile/getGroup']

        if (group && group.id) {
            let parameters = []
            parameters.push({
              id: 'group_id',
              value: group.id
            })
            parameters.push({
                id: 'messages',
                value: JSON.stringify(params.ids)
            })
            parameters.push({
                id: 'value',
                value: JSON.stringify(params.value)
            })     
            parameters.push({
                id: 'user_id',
                value: rootGetters['profile/getUserID'],
            })      

            let response = await dataClient('providerPageSet', {operation: 'group_message_confirm', parameters: parameters})

            return response
        }     
    },
    getGroupPage: async ({rootState, dispatch, commit, getters, rootGetters}) => {

        if (!getters.groupPage) {
            let group = rootGetters['profile/getGroup']

            if (group && group.id) {
                let parameters = []
                parameters.push({
                  id: 'group_id',
                  value: group.id
                })
                let response = await dataClient('providerPageGet', {operation: 'get_group', parameters: parameters})
            
                commit('setGroupPage', response)
            }

        }

        return getters.groupPage

    },  
    getGroupPageMessages: async ({rootState, dispatch, commit, getters, rootGetters}, params) => {

        let group = rootGetters['profile/getGroup']

        if (group && group.id) {
            commit('setGroupPageLoading', true) //setGroupPageLoading                 
            let parameters = []
            parameters.push({
                id: 'group_id',
                value: group.id
            })
            parameters.push({
                id: 'confirmed',
                value: params.confirmed ? 'true' : 'false'
            })    
            if (params.nextToken && params.nextToken !== '0') {
                parameters.push({
                    id: 'nextToken',
                    value: params.nextToken
                }) 
            }               
            let response = await dataClient('providerPageGet', {operation: 'get_group_messages', parameters: parameters})

            commit('setGroupPageLoading', false) //setGroupPageLoading     
            return response
        }


        return []

    },   
    
};

const mutations = {
    setList(state, {groups, linkedUsers}) {
        state.list = groups;
        // set admin list
        const merged = _.merge(_.keyBy(groups, 'user_id'), _.keyBy(linkedUsers, 'id'));
        const mergedUsers = _.values(merged);
        const adminLinkedUsers = mergedUsers.filter((user) => {
            return user.roles && user.roles.length && user.roles.find(role => role === 'group');
        })
        console.log('INFO: Admin linked users - ', adminLinkedUsers);
        state.adminList = adminLinkedUsers;
    },
    setMyGroup(state, group) {
        state.myGroup = group;
    },
    changeGroup(state, group) {
        state.selected = group;
    },
    resetState(state) {
        state.myGroup = {}
        state.selected = {}
        state.list = []
        state.adminList = []
    },
    setGroupPage(state, page) {
        state.groupPage = page
    },
    setGroupPageLoading(state, loading) {
        state.groupPageLoading = loading
    }    
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
